import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { CanvasService } from '../../services/canvas.service';
import { HttpService } from '../../services/http-service.service';
import { fabric } from 'fabric';
import { CropperComponent } from 'angular-cropperjs';
import { PlaceDetail } from '../../model/places';


@Component({
  selector: 'district-overview',
  templateUrl: './district-view.component.html',
  styleUrls: ['./district-view.component.scss']
})

export class DistrictViewComponent implements OnInit {

  @Input() locationInfo;
  @Input() index;
  @Input() canvasJson;
  @Input() isEditMode;

  @ViewChild('angularCropper1', { static: true }) angularCropper: CropperComponent;


  loading: boolean = false;
  address: any = {
    code: '',
    city: '',
    state: '',
    searchValue: ''
  };
  isShowMap: boolean = false;
  districtView: google.maps.Map;
  borderCoordinates: any = [];
  placesList: PlaceDetail[] = [];
  cityInfo: any = {
    lat: 0,
    lng: 0,
  }
  searchBox: google.maps.places.SearchBox;
  markers = [];
  showZipLoading: boolean = false;
  showSearchloading: boolean = false;
  idIndex = 0;

  // Canvas variable
  canvas: any;
  mapview: string = 'hybrid';
  zoomLevel: number = 13;
  imageWidth: number = 640;
  imageHeight: number = 500;
  imageSize: string = this.imageWidth + 'x' + this.imageHeight;
  staticGmapUrl: string = '';
  markerParam: string = '';
  isCropMode: boolean = false;
  cropConfig = {
    dragMode: 'move',
    background: false,
    minContainerWidth: 600,
    minContainerHeight: 428,
    movable: true,
    rotatable: true,
    scalable: true,
    zoomable: true,
    viewMode: 3,
    cropmove: this.cropMoved.bind(this),
    cropBoxResizable: false
  };
  shapeBorderColor: string = '#000000';
  shapeStroke: string = '#FFFF00';
  shapeFillColor: string = 'rgba(0,0,0,1)';
  shapeStrokeWidth: number = 3;
  croppedImage: any = '';
  isBlockMode: boolean = false;
  mapImage: string = '';
  markerIconURL = 'http://rbv.to/m/';

  constructor(
    public commonService: CommonService,
    public httpService: HttpService,
    public canvasService: CanvasService
  ) { }

  ngOnInit(): void {
    if (this.index)
      this.idIndex = this.index;
  }

  ngAfterViewInit(): void {
    this.canvas = new fabric.Canvas('mapCanvas' + this.idIndex);
    if (this.locationInfo) {
      setTimeout(() => {
        this.isBlockMode = true;
        this.address.code = this.locationInfo.ZIP;
        this.address.city = this.locationInfo.CITY;
        this.address.state = this.locationInfo.STATE;
        //this.address.searchValue = this.locationInfo.ADDRESS;
        this.submitAddress(false);
      });
    }
  }

  ngOnChanges(change): void {
    if (change.canvasJson && change.canvasJson.currentValue) {
      this.canvas.loadFromJSON(change.canvasJson.currentValue, function () {
        if (this) {
          this.canvas.renderAll();
        }
      }, function () {
      });
    }
    if (change.isEditMode) {
      this.isEditMode = change.isEditMode.currentValue;
      if (this.canvas) {
        this.canvas.loadFromJSON(this.canvas.toJSON(), this.canvas.renderAll.bind(this.canvas), function (o, object) {
          if (object.type == 'image') {
            object.set('selectable', false);
          } else {
            object.set('selectable', change.isEditMode.currentValue);
          }
        });
      }
    }
  }

  // downloadImage() - download image after doing process.
  downloadImage(): void {
    let image = this.canvas.toDataURL();
    var link = document.createElement('a');
    link.download = 'my-image.png';
    link.href = image;
    link.click();
  }

  // submitAddress() - submit city-state and get map of it.
  submitAddress(isChangeView: boolean): void {
    this.loading = true;
    let requestUrl = this.address.city + ',' + this.address.state + ',USA';

    this.httpService.getGeocode(requestUrl).subscribe((resp) => {
      if (resp.success) {
        if (resp['result'].status === 'OK' && resp['result'].results.length > 0) {
          this.isShowMap = true;
          this.cityInfo.lat = resp['result'].results[0].geometry.location.lat;
          this.cityInfo.lng = resp['result'].results[0].geometry.location.lng;

          setTimeout(() => {
            this.districtView = new google.maps.Map(document.getElementById('map-view' + this.idIndex), {
              center: { lat: this.cityInfo.lat, lng: this.cityInfo.lng },
              zoom: this.zoomLevel,
              streetViewControl: false,
              zoomControl: false,
              fullscreenControl: false,
              mapTypeId: google.maps.MapTypeId.ROADMAP
            });

            //Construct the border of the city.
            // var cityBorder = new google.maps.Polyline({
            //     path: this.borderCoordinates,
            //     geodesic: true,
            //     strokeColor: '#FF0000',
            //     strokeOpacity: 1.0,
            //     strokeWeight: 2
            // });

            // Draw the polyline on the desired map instance
            //cityBorder.setMap(this.districtView);

            // initialize searchbox
            this.findPlacesInCity();

            // load canvas
            this.mapLocation(isChangeView);

          }, 500);
        } else if (resp['result'].status === 'ZERO_RESULTS') {
          //this.toastrService.error('No city found.');
        }
      }
      this.loading = false;
    }, (error) => {
      if (error) {
        this.loading = false;
       // this.toastrService.error(error.message);
      }
    });
  }

  // getAddressBasedOnZip() - Get city and state based on zip
  getAddressBasedOnZip(): void {
    if (this.address.code.length == 5) {
      this.showZipLoading = true;
      this.httpService.getAddressBasedOnZip(this.address.code).subscribe((resp) => {
        if (resp.success) {
          if (resp['result']) {
            this.address.state = resp['result'].STATE;
            this.address.city = resp['result'].CITY;
          }
        } else {
          //this.toastrService.error(resp['error'].txt);
        }
        this.showZipLoading = false;
      }, (error) => {
        if (error) {
          this.showZipLoading = false;
          //this.toastrService.error(error.message);
        }
      });
    } else if (this.address.code.length < 5) {
      this.address.state = '';
      this.address.city = '';
    }
  }

  // findPlacesInCity() - Find places in the city.
  findPlacesInCity(): void {
    this.searchBox = new google.maps.places.SearchBox(document.getElementById('place-search' + this.idIndex) as HTMLInputElement);

    // Bias the SearchBox results towards current map's viewport.
    this.districtView.addListener('bounds_changed', () => {
      this.searchBox.setBounds(this.districtView.getBounds());

      // if (this.isBlockMode) {
      //   this.autoFillPlacesInCity();
      // }
    });

    // more details for that place.
    this.searchBox.addListener('places_changed', () => {
      this.showSearchloading = true;
      setTimeout(() => {
        // Clear out the old markers.
        this.markerParam = '';
        this.markers.forEach((marker) => {
          marker.setMap(null);
        });
        let list = this.searchBox.getPlaces();
        this.placesList = [];
        if (list && list.length > 0) {
          list.map((place) => {
            let placeDetail = new PlaceDetail();
            placeDetail.PLACE = place;
            placeDetail.IS_MARKED = false;
            placeDetail.IMAGE = '';
            this.placesList.push(placeDetail);
          });

          this.createMarkerParamString();
        }
        this.showSearchloading = false;
      }, 500);
    });
  }

  // autoFillPlacesInCity - Get list of places by address in given city.
  autoFillPlacesInCity(): void {
    const request = {
      query: this.address.searchValue,
      fields: ['place_id', 'name', 'formatted_address', 'icon', 'geometry'],
      bounds: this.districtView.getBounds() // bounds of location where we are going to search the places
    };

    this.showSearchloading = true;
    let placeService = new google.maps.places.PlacesService(this.districtView);
    placeService.textSearch(request, (results, status) => {
      if (status == google.maps.places.PlacesServiceStatus.OK) {
        if (results.length > 0) {
          results.map((place) => {
            let placeDetail = new PlaceDetail();
            placeDetail.PLACE = place;
            placeDetail.IS_MARKED = false;
            this.placesList.push(placeDetail);
          });
        }

        // After getting all places, create marker of it on canvas
        this.createMarkerParamString();
      }
      this.showSearchloading = false;
    });
  }

  // getPlaceDetailAndCreateMarker() - Get details about place and create marker on city.
  getPlaceDetailAndCreateMarker(placeIndex: number): void {
    let markerNumber = 0;
    this.placesList.map((place, index) => {
      if (index === placeIndex) {
        place.IS_MARKED = !place.IS_MARKED;
      }
      if(place.IS_MARKED){
        markerNumber += 1;
        place.MARKER_NUMBER = markerNumber;
      }
    });

    // After getting details create marker on canvas.
    this.createMarkerParamString();
  }

  // getPlaceAdditionalInfo() - Get place additional info
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  async getPlaceAdditionalInfo() {
    for (let i = 0; i < this.placesList.length; i++) {
      // If we have already got place detail then don't call API again
      if (this.placesList[i].IS_MARKED && !this.placesList[i].IS_EXTRA_DETAILS_GET) {
        await this.placeInfo(this.placesList[i]);
      }
    }
  }

  // placeInfo() - Get place info of place
  placeInfo(place): any {
    return new Promise((resolve) => {
      let service = new google.maps.places.PlacesService(this.districtView);
      var request = {
        placeId: place.PLACE.place_id,
        fields: ['rating', 'formatted_phone_number', 'website']
      };

      place.SHOW_DETAIL_LOADING = true;
      service.getDetails(request, (details, status) => {
        if (status == google.maps.places.PlacesServiceStatus.OK) {
          place.NUMBER = details.formatted_phone_number;
          place.RATING = details.rating;
          place.WEBSITE = details.website;
          place.SHOW_EXTRA_DETAIL = true;
          place.SHOW_DETAIL_LOADING = false;
          place.IS_EXTRA_DETAILS_GET = true;
        }
      //  resolve();
      });
    });
  }

  // createMarkerParamString() - Create string of all markers and get image of it.
  createMarkerParamString(): void {
    // Clear out the old markers.
    this.markers.forEach((marker) => {
      marker.setMap(null);
    });

    // Prepare param string for markers
    this.markerParam = '';

    // Add default marker to the main location
    this.markerParam += '&markers=' + btoa(this.cityInfo.lat + ',' + this.cityInfo.lng);

    let markerNumber = 0;
    this.placesList.map((place) => {
      if (place.IS_MARKED) {
        markerNumber += 1;
        this.markerParam += '&markers=';

        place.MARKER_NUMBER = markerNumber;
        let content = 'icon:' + this.markerIconURL + place.MARKER_NUMBER + '|';
        content += place.PLACE.geometry.location.lat() + ',' + place.PLACE.geometry.location.lng();

        this.markerParam += btoa(content);
      }
    });

    // After creating marker string call API
    this.mapLocation(true);
  }

  // mapLocation() - Get google map location and load it into canvas on the basis of user entered details
  mapLocation(isChangeView: boolean): void {

    // Get image of that location from google map
    let paramString = 'center=' + this.cityInfo.lat + ',' + this.cityInfo.lng
      + '&zoom=' + this.zoomLevel
      + '&scale=1'
      + '&size=' + this.imageSize
      + '&sensor=false'
      + '&maptype=' + this.mapview;
    if(this.markerParam){
      // paramString += '&markers=' + btoa(this.markerParam);
      paramString += this.markerParam;
    }else{
      paramString += '&markers=' + btoa(this.cityInfo.lat + ',' + this.cityInfo.lng);
    }

    this.httpService.getMapImage(paramString).subscribe((resp) => {
      this.mapImage = this.commonService._imageEncode(resp);

      // Load image of that location into canvas
      fabric.Image.fromURL(this.mapImage, (image) => {
        image.set({ left: 0, top: 0 });

        // If we are changing view just change image else add new one
        if (isChangeView) {
          this.canvas.item(0).set(image);
          this.canvas.renderAll();
        } else this.canvas.add(image);
        this.canvas.item(0).lockMovementX = true;
        this.canvas.item(0).lockMovementY = true;
        this.canvas.item(0).selectable = false;
      }, {
        crossOrigin: 'anonymous'
      });
    }, (error) => {
      if (error) {
       // this.toastrService.error(error.message);
      }
    });

    // If image gets changed then reinitalize cropper.
    if (isChangeView && this.angularCropper.cropper) {
      let testData1 = this.angularCropper.cropper;
      this.angularCropper.cropper.destroy();
      this.angularCropper.cropper = testData1;
    }
  }

  // zoomIn() - Zoom in on the map
  zoomIn(): void {
    this.zoomLevel = this.zoomLevel + 1;
    this.mapLocation(true);
  }

  // zoomOut() - Zoom out on the map
  zoomOut(): void {
    this.zoomLevel = this.zoomLevel - 1;
    this.mapLocation(true);
  }

  // moveLeft() - Move left
  moveLeft(): void {
    this.cityInfo.lng = this.cityInfo.lng - this.commonService.getValAccordingToZoomLevel(this.zoomLevel);
    this.mapLocation(true);
  }

  // moveRight() - Move right
  moveRight(): void {
    this.cityInfo.lng = this.cityInfo.lng + this.commonService.getValAccordingToZoomLevel(this.zoomLevel);
    this.mapLocation(true);
  }

  // moveTop() - Move top
  moveTop(): void {
    this.cityInfo.lat = this.cityInfo.lat + this.commonService.getValAccordingToZoomLevel(this.zoomLevel);
    this.mapLocation(true);
  }

  // moveDown() - Move down
  moveDown(): void {
    this.cityInfo.lat = this.cityInfo.lat - this.commonService.getValAccordingToZoomLevel(this.zoomLevel);
    this.mapLocation(true);
  }

  // changeMapView() - Change view of the map, satellite or hybrid
  changeMapView(): void {
    this.mapview = this.mapview === 'HYBRID' ? 'hybrid' : this.mapview === 'hybrid' ? 'HYBRID' : 'hybrid';
    this.mapLocation(true);
  }

  // selectShapeBorderWidth() - Select width of the border
  selectShapeBorderWidth(width: number): void {
    this.shapeStrokeWidth = width;
    if (this.canvas.getActiveObject()) {
      this.canvas.getActiveObject().set('strokeWidth', this.shapeStrokeWidth);
      this.canvas.renderAll();
    }
  }

  // cropAnImage() - Crop an image when user select crop area
  cropAnImage(): void {
    if (this.isCropMode) {
      // Load image of that location into canvas
      fabric.Image.fromURL(encodeURI(this.croppedImage), (image) => {
        image.set({ left: 0, top: 0 });
        image.width = this.imageWidth;
        image.height = this.imageHeight;
        this.canvas.item(0).set(image);
        this.canvas.renderAll();

        this.canvas.item(0).lockMovementX = true;
        this.canvas.item(0).lockMovementY = true;
        this.canvas.item(0).selectable = false;
      }, {
        crossOrigin: 'anonymous'
      });
    } else {
      this.croppedImage = '';
      this.angularCropper.cropper.setCropBoxData({ top: 10, left: 10, height: 350, width: 380 });
    }
    this.isCropMode = !this.isCropMode;
  }

  // cropMoved() - Create new image when user moves crop box
  cropMoved(): void {
    this.croppedImage = this.angularCropper.cropper.getCroppedCanvas().toDataURL();
  }

}
